import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private _http:HttpClient) { }


  getFicheBdd(pas){
    return this._http.get("http://www.testback.kompar-energie.com/article/get/all/"+pas);
  }
  
  getFicheBlack(){
    return this._http.get("http://www.testback.kompar-energie.com/listenoire/get/all");
  }

  
  getFicheprovisoir(pas){
    return this._http.get("http://www.testback.kompar-energie.com/article/exportProvesoir/"+pas);
  }

  getFicheprovisoir1(pas){
    return this._http.get("http://www.testback.kompar-energie.com/article/getProvesoir/"+pas);
  }
  uploadBlack(formData: FormData){
    return this._http.post("http://www.testback.kompar-energie.com/listenoir/upload",formData);
  }
  uploadBDD(formData: FormData){
    return this._http.post("http://www.testback.kompar-energie.com/article/up",formData);
  }
  uploadBDD1(formData){
    return this._http.post("http://www.testback.kompar-energie.com/article/import",formData);
  }
  uploadProvesoir(formData: FormData){
    return this._http.post("http://www.testback.kompar-energie.com/provesoir/upload",formData);
  }

  routerLink(pas){
    return this._http.get("http://www.testback.kompar-energie.com/article/export/"+pas);
  }

  getFicheFiltrer(filtre){
    return this._http.post('http://www.testback.kompar-energie.com/article/get/filtrer',filtre);
  }

  getFicheFiltrer1(filtre){
    return this._http.post('http://www.testback.kompar-energie.com/article/export/filtrer',filtre);
  }
  deleteByGid(data){
    return this._http.delete('http://www.testback.kompar-energie.com/blackliste/deleteByGid',
      data
    )
  }
  deleteBdd(id){
    return this._http.delete('http://www.testback.kompar-energie.com/article/delete/'+id);
  }
  updateFiche(id,data){
    return this._http.put('http://www.testback.kompar-energie.com/article/update/'+id,data)
  }
  supprimerBdd(){
    return this._http.delete("http://www.testback.kompar-energie.com/article/deletee/all");
  }
}
